import { BetSlipSetting, UserData } from '../types/auth.type'

export function mergeRenewedUserFields(rawUser: unknown, currentUserFields?: UserData['user_fields']): UserData['user_fields'] {
	if (!rawUser || typeof rawUser !== 'object') return currentUserFields ?? ({} as UserData['user_fields'])

	const renewedUserFields = rawUser as Record<string, unknown>

	return {
		...currentUserFields,
		...renewedUserFields,
		USER_BETSLIP: parseBetSlipSetting(renewedUserFields['USER_BETSLIP'], currentUserFields?.USER_BETSLIP ?? null),
		WHITE_LABEL_BET_SLIP: parseBetSlipSetting(renewedUserFields['WHITE_LABEL_BET_SLIP'], currentUserFields?.WHITE_LABEL_BET_SLIP ?? null),
	} as UserData['user_fields']
}

function parseBetSlipSetting(value: unknown, fallback: BetSlipSetting | null): BetSlipSetting | null {
	if (value && typeof value === 'object') return value as BetSlipSetting
	if (typeof value !== 'string') return fallback

	try {
		const parsed = JSON.parse(value) as unknown
		return parsed && typeof parsed === 'object' ? (parsed as BetSlipSetting) : fallback
	} catch {
		return fallback
	}
}
